import BadgeHistoryList from "../../components/badgeHistory/BadgeHistoryList";
import NavLinksAdmin from "../../components/navlinksAdmin/NavLinksAdmin";

const AdminBadgeHistory = () => {
  return (
    <div className="inside-page-container-blk">
      <div className="admin-page-main-container">
        <NavLinksAdmin />
        <div>
          <BadgeHistoryList />
        </div>
      </div>
    </div>
  );
};

export default AdminBadgeHistory;
